import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Link,
} from '@mui/material';

const SignupPage = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your signup logic here
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: '100px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography variant="h4" align="center" gutterBottom>
          Signup
        </Typography>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            width: '300px',
          }}
        >
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            required
          />
          <TextField
            label="Email"
            variant="outlined"
            type="email"
            fullWidth
            required
          />
          <TextField
            label="Password"
            variant="outlined"
            type="password"
            fullWidth
            required
          />
          <Button variant="contained" type="submit" color="primary" fullWidth>
            Signup
          </Button>
        </Box>
        <Typography variant="body2" align="center" mt={2}>
          Already have an account?{' '}
          <Link component={RouterLink} to="/login">
            Login
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default SignupPage;
